import { render, staticRenderFns } from "./RewardEditor.vue?vue&type=template&id=66f1c340&scoped=true&"
import script from "./RewardEditor.vue?vue&type=script&lang=js&"
export * from "./RewardEditor.vue?vue&type=script&lang=js&"
import style0 from "./RewardEditor.vue?vue&type=style&index=0&id=66f1c340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1c340",
  null
  
)

export default component.exports